import { useState } from "react";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { MobileNotFound } from "../auth/MobileAuthStates";
import { useIsMobileShell } from "../../hooks/useIsMobileShell";
import { isMobileStandalonePwa } from "../../utils/isStandalonePwa";
import Login from "../../pages/Login";
import Landing from "../../pages/Landing";
import TermsOfUse from "../../pages/legal/TermsOfUse";
import PrivacyPolicy from "../../pages/legal/PrivacyPolicy";
import Settings from "../../pages/Settings";
import MyAccount from "../../pages/MyAccount";
import Plans from "../../pages/Plans";
import PrivateRoute from "../PrivateRoute";
import AdminRoute from "../AdminRoute";
import TrialGuard from "../TrialGuard";
import MainView from "./Main";
import Sale from "../../pages/Sale";
import DashboardsHub from "../../pages/dashboards/DashboardsHub";
import Home from "../../pages/Home";
import MobileMore from "../../pages/MobileMore";
import AiChat from "../../pages/AiChat";
import Products from "../../pages/products/List";
import Form from "../../pages/products/Form";
import Import from "../../pages/products/Import";
import Reposition from "../../pages/products/Reposition";
import PurchaseImport from "../../pages/purchases/Import";
import PurchaseManual from "../../pages/purchases/Manual";
import Purchases from "../../pages/purchases/List";
import PurchaseView from "../../pages/purchases/View";
import Categories from "../../pages/categories/List";
import CategoryForm from "../../pages/categories/Form";
import Sales from "../../pages/sales/List";
import View from "../../pages/sales/View";
import Generate from "../../pages/service_order/Genereate";
import Operator from "../../pages/service_order/Operator";
import List from "../../pages/service_order/List";
import ServiceOrderBilling from "../../pages/service_order/Billing";
import UpcomingServices from "../../pages/service_order/UpcomingServices";
import Customers from "../../pages/customers/List";
import CustomerForm from "../../pages/customers/Form";
import CustomerView from "../../pages/customers/View";
import ViewServiceOrder from "../../pages/service_order/View";
import ServiceQuotesList from "../../pages/service_quotes/List";
import ServiceQuotesGenerate from "../../pages/service_quotes/Generate";
import ServiceQuotesOperator from "../../pages/service_quotes/Operator";
import ServiceQuotesView from "../../pages/service_quotes/View";
import VehicleForm from "../../pages/vehicles/Form";
import Vehicles from "../../pages/vehicles/List";
import ServiceForm from "../../pages/services/Form";
import Services from "../../pages/services/List";
import ServiceImport from "../../pages/services/Import";
import Users from "../../pages/users/List";
import UserForm from "../../pages/users/Form";
import Profiles from "../../pages/profiles/List";
import ProfileForm from "../../pages/profiles/Form";
import Suppliers from "../../pages/suppliers/List";
import SupplierForm from "../../pages/suppliers/Form";
import Inventories from "../../pages/inventory/List";
import InventoryForm from "../../pages/inventory/Form";
import InventoryView from "../../pages/inventory/View";
import InventoryReport from "../../pages/inventory/Report";
import CashRegisters from "../../pages/cashregisters/List";
import CashRegisterForm from "../../pages/cashregisters/Form";
import CashRegisterView from "../../pages/cashregisters/View";
import CashRegisterHistory from "../../pages/cashregisters/History";
import Sangria from "../../pages/cashregisters/Sangria";
import Close from "../../pages/cashregisters/Close";
import Open from "../../pages/cashregisters/Open";
import Reports from "../../pages/reports";
import StockReport from "../../pages/reports/StockReport";
import SalesReport from "../../pages/reports/SalesReport";
import ProductReport from "../../pages/reports/ProductReport";
import ServiceOrderReport from "../../pages/reports/ServiceOrderReport";
import CustomerReport from "../../pages/reports/CustomerReport";
import VehicleReport from "../../pages/reports/VehicleReport";
import ChecklistReport from "../../pages/reports/ChecklistReport";
import CashFlowReport from "../../pages/reports/CashFlowReport";
import CardMachinesList from "../../pages/card_machines/List";
import CardMachineForm from "../../pages/card_machines/Form";
import ChecklistForm from "../../pages/vehicles/checklist/Form";
import ChecklistList from "../../pages/vehicles/checklist/List";
import ChecklistGroupForm from "../../pages/vehicles/checklist/GroupForm";
import ChecklistView from "../../pages/vehicles/checklist/View";
import ChecklistFiller from "../../pages/vehicles/checklist/Filler";
import ListInspGroup from "../../pages/vehicles/checklist/ListInspGroup";
import TransactionForm from "../../pages/transactions/Form";
import TransactionsList from "../../pages/transactions/List";
import PayablesList from "../../pages/accounts/PayablesList";
import ReceivablesList from "../../pages/accounts/ReceivablesList";
import ChangePassword from "../../pages/ChangePassword";
import SubscriptionActivate from "../../pages/SubscriptionActivate";
import PermissionsList from "../../pages/admin/permissions/List";
import PermissionForm from "../../pages/admin/permissions/Form";
import SubscriptionsList from "../../pages/admin/subscriptions/List";
import TenantForm from "../../pages/admin/subscriptions/TenantForm";
import SubscriptionResources from "../../pages/admin/subscriptions/Resources";
import PlansList from "../../pages/admin/plans/List";
import PlanForm from "../../pages/admin/plans/Form";
import PlanView from "../../pages/admin/plans/View";
import ConfigurationList from "../../pages/admin/configuration/List";
import AdminWhatsapp from "../../pages/admin/whatsapp";
import AuditLogsList from "../../pages/audit/List";
import CustomerOrderDisplayScreen from "../../CustomerOrderDisplayScreen";
import CustomerQuoteDisplayScreen from "../../CustomerQuoteDisplayScreen";

const NotFound = () => {
    const isMobileShell = useIsMobileShell();
    if (isMobileShell) return <MobileNotFound />;
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh'
        }}>
            <h1>404</h1>
            <h2>Página não encontrada</h2>
            <Link to="/home" style={{
                textDecoration: 'none',
                color: '#1976d2',
                marginTop: '20px'
            }}>Voltar para página inicial</Link>
        </div>
    )
}

// Em PWA instalado no celular, "/" pula a Landing: logado vai para /home, senão para /login.
// Navegador comum e desktop continuam vendo a Landing.
const IndexRoute = ({ isAuthenticated }) => {
    const location = useLocation();
    if (isMobileStandalonePwa()) {
        if (isAuthenticated && localStorage.getItem('access_token') !== null) return <Navigate to="/home" replace />;
        return <Navigate to={{ pathname: "/login", search: location.search }} replace />;
    }
    return <Landing />;
}

export default function DefaultRouter() {
    const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem('access_token') !== null);
   
    return (
        <Routes>
            <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
            <Route path="/" element={<IndexRoute isAuthenticated={isAuthenticated} />} />
            <Route path="/termos-de-uso" element={<TermsOfUse />} />
            <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
            <Route path="/changepassword" element={<ChangePassword />} />
            <Route path="/subscription/activate" element={<SubscriptionActivate />} />
            <Route path="/ordem/:numero_ordem" element={<CustomerOrderDisplayScreen />} />
            <Route path="/orcamento/:id" element={<CustomerQuoteDisplayScreen />} />
            <Route element={<PrivateRoute isAuthenticated={isAuthenticated} />}>
              <Route element={<TrialGuard />}>
                <Route element={<MainView />}>
                    <Route path="/home" element={<Home />} />
                    <Route path="/more" element={<MobileMore />} />
                    <Route path="/chat" element={<AiChat />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/myaccount" element={<MyAccount />} />
                    <Route path="/plans" element={<Plans />} />
                    <Route path="/products/new" element={<Form />} />
                    <Route path="/products/edit/:id" element={<Form />} />
                    <Route path="/products/import" element={<Import />} />
                    <Route path="/products/:id/reposition" element={<Reposition />} />
                    <Route path="/purchases" element={<Purchases />} />
                    <Route path="/purchases/import" element={<PurchaseImport />} />
                    <Route path="/purchases/new" element={<PurchaseManual />} />
                    <Route path="/purchases/:reference" element={<PurchaseView />} />
                    <Route path="/categories" element={<Categories />} />
                    
                    <Route path="/categories/new" element={<CategoryForm />} />
                    <Route path="/categories/edit/:id" element={<CategoryForm />} />
                    <Route path="/sales" element={<Sales />} />
                    <Route path="/sales/:id" element={<View />} />
                    <Route path="/dashboards" element={<DashboardsHub />} />
                    <Route path="/dashboards/:tab" element={<DashboardsHub />} />
                    {/* Rotas antigas: redirecionam para o hub (links salvos/externos). */}
                    <Route path="/dashboard/sale" element={<Navigate to="/dashboards/sale" replace />} />
                    <Route path="/dashboard/order" element={<Navigate to="/dashboards/order" replace />} />
                    <Route path="/dashboard/vehicle" element={<Navigate to="/dashboards/vehicle" replace />} />
                    <Route path="/dashboard/quote" element={<Navigate to="/dashboards/quote" replace />} />
                    <Route path="/dashboard/customer" element={<Navigate to="/dashboards/customer" replace />} />
                    <Route path="/dashboard/product" element={<Navigate to="/dashboards/product" replace />} />
                    <Route path="/serviceorder/generate" element={<Generate />} />
                    <Route path="/serviceorder/:id/operator" element={<Operator />} />
                    <Route path="/serviceorders" element={<List />} />
                    <Route path="/billing/serviceorders" element={<ServiceOrderBilling />} />
                    <Route path="/serviceorders/upcoming" element={<UpcomingServices />} />
                    <Route path="/customers" element={<Customers />} />
                    <Route path="/serviceorders/:id/view" element={<ViewServiceOrder />} />
                    <Route path="/servicequotes" element={<ServiceQuotesList />} />
                    <Route path="/servicequotes/generate" element={<ServiceQuotesGenerate />} />
                    <Route path="/servicequotes/:id/operator" element={<ServiceQuotesOperator />} />
                    <Route path="/servicequotes/:id/view" element={<ServiceQuotesView />} />
                    <Route path="/vehicles/new" element={<VehicleForm />} />
                    <Route path="/vehicles/edit/:id" element={<VehicleForm />} />
                    <Route path="/vehicles" element={<Vehicles />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/services/new" element={<ServiceForm />} />
                    <Route path="/services/edit/:id" element={<ServiceForm />} />
                    <Route path="/services/import" element={<ServiceImport />} />
                    <Route path="/customers/new" element={<CustomerForm />} />
                    <Route path="/customers/edit/:id" element={<CustomerForm />} />
                    <Route path="/customers/view/:id" element={<CustomerView />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/users/new" element={<UserForm />} />
                    <Route path="/users/edit/:id" element={<UserForm />} />
                    <Route path="/profiles" element={<Profiles />} />
                    <Route path="/profiles/new" element={<ProfileForm />} />
                    <Route path="/profiles/edit/:id" element={<ProfileForm />} />
                    <Route path="/suppliers" element={<Suppliers />} />
                    <Route path="/suppliers/new" element={<SupplierForm />} />
                    <Route path="/suppliers/edit/:id" element={<SupplierForm />} />
                    <Route path="/inventory" element={<Inventories />} />
                    <Route path="/inventory/new" element={<InventoryForm />} />
                    <Route path="/inventory/:id" element={<InventoryView />} />
                    <Route path="/cashregisters" element={<CashRegisters />} />
                    <Route path="/cashregisters/new" element={<CashRegisterForm />} />
                    <Route path="/cashregisters/edit/:id" element={<CashRegisterForm />} />
                    <Route path="/cashregisters/view/:id" element={<CashRegisterView />} />
                    <Route path="/cashregisters/history/:id" element={<CashRegisterHistory />} />
                    <Route path="/cashregisters/sangria/:id" element={<Sangria />} />
                    <Route path="/cashregisters/close/:id" element={<Close />} />
                    <Route path="/cashregisters/open/:id" element={<Open />} />
                    <Route path="/reports" element={<Reports />} />
                    <Route path="/reports/stock" element={<StockReport />} />
                    <Route path="/reports/sales" element={<SalesReport />} />
                    <Route path="/reports/products" element={<ProductReport />} />
                    <Route path="/reports/serviceorder" element={<ServiceOrderReport />} />
                    <Route path="/reports/customers" element={<CustomerReport />} />
                    <Route path="/reports/vehicles" element={<VehicleReport />} />
                    <Route path="/reports/checklist" element={<ChecklistReport />} />
                    <Route path="/reports/inventory" element={<InventoryReport />} />
                    <Route path="/reports/cash-flow"element={<CashFlowReport />} />
                    <Route path="/cardmachines" element={<CardMachinesList />} />
                    <Route path="/cardmachines/new" element={<CardMachineForm />} />
                    <Route path="/cardmachines/edit/:id" element={<CardMachineForm />} />
                    <Route path="/whatsapp" element={<Navigate to="/settings?tab=integrations" replace />} />
                    <Route path="/vehicle_checklist" element={<ChecklistList />} />
                    <Route path="/vehicle_checklist/new" element={<ChecklistForm />} />
                    <Route path="/checklist/:id/edt" element={<ChecklistForm />} />
                    <Route path="/checklist/:id/view" element={<ChecklistView />} />
                    <Route path="/checklist/:id/fill" element={<ChecklistFiller />} />
                    <Route path="/checklist/:id/group" element={<ChecklistGroupForm />} />
                    <Route path="/checklist/:id/group/new" element={<ChecklistGroupForm />} />
                    <Route path="/checklist/groups" element={<ListInspGroup />} />
                    <Route path="/checklist/group/add" element={<ChecklistGroupForm />} />
                    <Route path="/checklist/group/edt" element={<ChecklistGroupForm />} />
                    <Route path="/checklist/:id/group/edt" element={<ChecklistGroupForm />} />
                    <Route path="/transactions" element={<TransactionsList />} />
                    <Route path="/transactions/new" element={<TransactionForm />} />
                    <Route path="/accounts/payable" element={<PayablesList />} />
                    <Route path="/accounts/receivable" element={<ReceivablesList />} />
                    <Route path="/audit/logs" element={<AuditLogsList />} />
                    <Route element={<AdminRoute />}>
                        <Route path="/admin/permissions" element={<PermissionsList />} />
                        <Route path="/admin/permissions/edit/:id" element={<PermissionForm />} />
                        <Route path="/admin/subscriptions" element={<SubscriptionsList />} />
                        <Route path="/admin/subscriptions/new" element={<TenantForm />} />
                        <Route path="/admin/subscriptions/resources" element={<SubscriptionResources />} />
                        <Route path="/admin/plans" element={<PlansList />} />
                        <Route path="/admin/plans/new" element={<PlanForm />} />
                        <Route path="/admin/plans/edit/:id" element={<PlanForm />} />
                        <Route path="/admin/plans/view/:id" element={<PlanView />} />
                        <Route path="/admin/configuration" element={<ConfigurationList />} />
                        <Route path="/admin/whatsapp" element={<AdminWhatsapp />} />
                    </Route>
                </Route>
                <Route path="/sale" element={<Sale />} />
              </Route>
            </Route>
            <Route path="*" element={<NotFound />} />
        </Routes>
    )
}